export default __webpack_public_path__ + "static/media/searchClose.26e98fd6.svg";